var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgZapier = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_6639)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_201_6639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00407 0.5C7.37126 0.500675 7.73239 0.531704 8.08345 0.59039V4.37461L10.7663 1.69867C11.0626 1.90913 11.3398 2.1432 11.5961 2.39886C11.8525 2.65451 12.0879 2.93176 12.2989 3.22721L9.61589 5.90314H13.41C13.4689 6.25323 13.5 6.6121 13.5 6.97905V6.98782C13.5 7.35477 13.4689 7.71431 13.41 8.0644H9.61525L12.2989 10.7397C12.0879 11.0351 11.8525 11.3124 11.5969 11.568H11.5961C11.3398 11.8237 11.0626 12.0584 10.7671 12.2682L8.08345 9.59224V13.3765C7.73304 13.4352 7.37191 13.4662 7.00471 13.4669H6.99529C6.62796 13.4662 6.26825 13.4352 5.91719 13.3765V9.59224L3.23436 12.2682C2.64186 11.8479 2.12385 11.3306 1.70178 10.7397L4.38475 8.0644H0.590637C0.531116 7.71362 0.5 7.35274 0.5 6.98579V6.96695C0.500617 6.87173 0.506852 6.75539 0.515809 6.63504L0.518574 6.59883C0.545094 6.26005 0.590637 5.90314 0.590637 5.90314H4.38475L1.70178 3.22721C1.91211 2.93176 2.14684 2.65518 2.40313 2.40021L2.40442 2.39886C2.66019 2.1432 2.93804 1.90913 3.23436 1.69867L5.91719 4.37461V0.59039C6.26825 0.531704 6.62874 0.500675 6.99658 0.5H7.00407ZM7.00342 5.36283H6.99722C6.51434 5.36283 6.05186 5.45119 5.62437 5.61173C5.46414 6.03738 5.37544 6.49876 5.37479 6.98039V6.98646C5.37544 7.46809 5.46414 7.92949 5.62501 8.35512C6.05186 8.51567 6.51434 8.60404 6.99722 8.60404H7.00342C7.4863 8.60404 7.94879 8.51567 8.37563 8.35512C8.53651 7.92882 8.62521 7.46809 8.62521 6.98646V6.98039C8.62521 6.49876 8.53651 6.03738 8.37563 5.61173C7.94879 5.45119 7.4863 5.36283 7.00342 5.36283Z",
    fill: "#FF4A00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_6639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_201_6639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZapier);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Zapier.16aef912ebbc16158eb75f3d729cde47.svg";